/* global pca */
import $ from 'jquery';

/**
 * Change read-only field to allow editing
 */
class Address {
    constructor () {
        this.$addressFieldsWrapper       = $('.js-address-wrapper');
        this.$manuallyEnterAddressbutton = $('.js-manually-enter-address');
        this.$form                       = this.$addressFieldsWrapper.closest('form');

        // Show the fields on button click.
        this.$manuallyEnterAddressbutton.on('click', $.proxy(Address.buttonClick, this));

        // Show the fields on PCA Predict change.
        this.$addressFieldsWrapper.find('input').on('change', $.proxy(this.fieldChange, this));

        // Show all the hidden address fields on form submission (for validation).
        this.$form.find('[type=submit]').on('click', () => {
            this.$addressFieldsWrapper.show();
        });
    }

    static buttonClick (e) {
        const $elem = $(e.currentTarget);

        // Show the address fields.
        $elem.next('.js-address-wrapper').show();

        // Hide the button.
        $elem.hide();
    }

    fieldChange (e) {
        const $elem = $(e.currentTarget);

        // - Not the country field.
        // - Not an empty value.
        if (!$elem.attr('id').includes('_country') && $elem.val() !== '') {
            // Show the address fields.
            $elem.closest(this.$addressFieldsWrapper).show();

            // Hide the button.
            $elem.closest(this.$addressFieldsWrapper).parent().find(this.$manuallyEnterAddressbutton).hide();
        }
    }
}

export default Address;
